// Modules
import styled from 'styled-components'
import { Link } from 'theme-ui'

export const Container = styled.div`
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    height: 100dvh;
`

export const Content = styled.div`
    display: flex;
    flex: 3;
    background-color: #fff;
    overflow-y: auto;
    flex-direction: column;
    width: 100%;
`

export const ContainerPage = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    max-width: 100%;
    width: 434px;
    margin: 0 auto;
    padding: 2rem 1rem;
    justify-content: center;

    @media (max-width: 480px) {
        width: 100%;
        padding: 2rem 1rem 0.5rem 1rem;
    }
`

export const Text = styled.p`
    color: #666;
    font-size: 14px;

    @media (max-width: 767px) {
        color: #fefefe;
        font-size: 12px;
    }
`

export const ButtonLink = styled(Link)`
    color: #0066cc;
    cursor: pointer;
    font-size: 14px;

    @media (max-width: 767px) {
        font-size: 12px;
    }
`

export const ContentButton = styled.div`
    margin-top: auto;
    padding-top: 16px;
    padding-bottom: 16px;
    text-align: center;
    min-height: 50px;

    @media (min-width: 768px) {
        padding-bottom: 24px;
    }

    @media (max-width: 767px) {
        background-color: #0037ff;
    }
`
